import React from 'react'

class SocialBar extends React.Component {
	render() {
		const { user } = this.props
		const { _id, name, username } = user
		return (
			<div className="social">
				<h2 className="subtitle">Share this profile</h2>
				<div className="btns d-flex">
					<a className="btn btn-twitter" target="_blank" href={"https://twitter.com/intent/tweet?text=Check%20out%20" + name +"'s%20profile%20on%20TheFlightPost%20at:&url=https://theflightpost.com/profile/" + username}><span className="social-icon"><svg viewBox="0 0 512 512"><path d="M443.8 159.7c.3 4.2.3 8.4.3 12.6 0 128.1-97.5 275.7-275.7 275.7-54.9 0-105.9-15.9-148.8-43.5 7.8.9 15.3 1.2 23.4 1.2 45.3 0 87-15.3 120.3-41.4-42.6-.9-78.3-28.8-90.6-67.2 6 .9 12 1.5 18.3 1.5 8.7 0 17.4-1.2 25.5-3.3-44.4-9-77.7-48-77.7-95.1V199c12.9 7.2 27.9 11.7 43.8 12.3-26.1-17.4-43.2-47.1-43.2-80.7 0-18 4.8-34.5 13.2-48.9 47.7 58.8 119.4 97.2 199.8 101.4-1.5-7.2-2.4-14.7-2.4-22.2 0-53.4 43.2-96.9 96.9-96.9 27.9 0 53.1 11.7 70.8 30.6 21.9-4.2 42.9-12.3 61.5-23.4-7.2 22.5-22.5 41.4-42.6 53.4 19.5-2.1 38.4-7.5 55.8-15-13.2 19.2-29.7 36.3-48.6 50.1z"></path></svg></span></a>
					<a className="btn btn-facebook fb-xfbml-parse-ignore" target="_blank" href={"https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Ftheflightpost.com%2Fprofile%2F"+ username +"&amp;src=sdkpreparse"}><span className="social-icon"><svg viewBox="0 0 264 512"><path d="M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229"></path></svg></span></a>
				</div>
			</div>
		)
	}
}

export default SocialBar


// WEBPACK FOOTER //
// ./src/components/Global/SocialBar.js